export default {
  placeholder: 'Videos, articles, or folders...',
  videos: 'Videos',
  videos_placeholder: 'Search for videos',
  no_results_found: 'No matching results found! Try with different search term',
  empty: 'Start typing!!!',
  courses_placeholder: 'Search for courses',
  learners_placeholder:'Search for learners'
};
